"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.action('REMOVE_MESSAGEAD', function (removeAdId) {
    return {
        removeAdId: removeAdId,
    };
});
//# sourceMappingURL=removeMessageAd.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-messagead-store/lib/actions/removeMessageAd.js
// module id = 3113
// module chunks = 17 67